import type { ProductOverdueSummary as ProductOverdueSummaryType } from "#/types/report";
import { formatCurrency } from "#/utils/formatCurrency";
import { useTranslation } from "react-i18next";
import ReportLink from "./ReportLink";

interface ProductOverdueSummaryProps {
  products: ProductOverdueSummaryType[];
}

const MAX_PRODUCTS_TO_SHOW = 5;

const ProductOverdueSummary = ({ products }: ProductOverdueSummaryProps) => {
  const { t } = useTranslation();
  const displayedProducts = products.slice(0, MAX_PRODUCTS_TO_SHOW);

  return (
    <div className="flex flex-col gap-2">
      <span className="text-xs font-medium uppercase tracking-wider text-gray-500">
        {t("reports.inventoryScan.overdue.byProduct")}
      </span>
      <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3">
        {displayedProducts.map((product) => (
          <div
            key={product.productSku || product.productName || "unknown"}
            className="flex items-center justify-between rounded-md border border-gray-200 bg-gray-50 px-3 py-2"
          >
            <div className="flex flex-col">
              <span className="text-sm font-medium text-gray-800">
                {product.productId ? (
                  <ReportLink href={`/inventory/categories/${product.productId}`}>
                    {product.productName || product.productSku || "Unknown"}
                  </ReportLink>
                ) : (
                  product.productName || product.productSku || "Unknown"
                )}
              </span>
              <span className="text-xs text-gray-500">
                {product.itemCount} {t("reports.inventoryScan.overdue.items")}
              </span>
            </div>
            <span className="text-sm font-semibold text-gray-900">
              {formatCurrency(product.estimatedValue)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductOverdueSummary;
